import { AiOutlineHome } from 'react-icons/ai';
import { BsBook, BsBuildings, BsCollection, BsList, BsPeople } from 'react-icons/bs';
import { PiGearBold } from 'react-icons/pi';
import { GiBookshelf, GiGears } from 'react-icons/gi';
import { GiPipes } from 'react-icons/gi';
import { SiMediafire } from 'react-icons/si';
import { TiDocumentText } from 'react-icons/ti';
import { IoDocuments } from 'react-icons/io5';
import { HiDocumentDuplicate } from 'react-icons/hi';
import { CgPlayListSearch } from 'react-icons/cg';
import { MdManageAccounts } from 'react-icons/md';
import { IoLibraryOutline } from 'react-icons/io5';
import { LuLibraryBig } from "react-icons/lu";
import { ReactElement } from 'react';

export type SidebarItem = {
  title: string;
  path: string;
  icon: ReactElement;
  cName: string;
  roles?: string[];
  dynamicSubNav?: boolean;
};

export type SidebarGroup = {
  title: string;
  path: string;
  icon: ReactElement;
  cName: string;
  roles?: string[];
  subNav?: SidebarItem[];
};

// Accept the dynamic data here
export const buildSidebarData = (categories: { id: number; name: string }[]) => {
  return [
    {
      title: "Home",
      path: "/home",
      icon: <AiOutlineHome />,
      cName: "nav-text text-left",
      roles: ["Admin", "User"],
    },
     {
      title: "Library Category",
      path: "/library/library-category",
      icon: <GiBookshelf />,
      cName: "nav-text text-left",
      roles: ["Admin"],
    },
    {
      title: "Private Library",
      path: "#",
      icon: <BsBook />,
      cName: "sub-nav-text",
      roles: ["Admin", "User"],
      subNav: [
        // 🔽 Inject dynamic categories
        ...categories && categories.map((cat) => ({
          title: cat.name,
          path: `/library/private-library/${cat.id}`,
          icon: <LuLibraryBig />,
          cName: "sub-nav-text",
        })),
      ],
    },
    {
      title: "AI Dharma Library",
      path: "/pdf-library",
      icon: <IoLibraryOutline />,
      cName: "nav-text text-left",
      roles: ["Admin", "user"],
    },
    {
      title: "DataSource Mangement",
      path: "#",
      icon: <BsList />,
      cName: "sub-nav-text",
      roles: ["Admin"],
      subNav: [
        {
          title: "Agent Master",
          path: "/data-source/agent-master",
          icon: <MdManageAccounts />,
          cName: "sub-nav-text",
        },
        {
          title: "Value Chain Category",
          path: "/data-source/value-chain-category",
          icon: <GiGears />,
          cName: "sub-nav-text",
        },
        {
          title: "Value Chain",
          path: "/data-source/value-chain",
          icon: <PiGearBold />,
          cName: "sub-nav-text",
        },
        {
          title: "Data Pipeline Category",
          path: "/data-source/data-pipeline-category",
          icon: <GiPipes />,
          cName: "sub-nav-text",
        },
        {
          title: "Data Pipeline",
          path: "/data-source/data-pipeline",
          icon: <SiMediafire />,
          cName: "sub-nav-text",
        },
        {
          title: "Term Set",
          path: "/data-source/term-set",
          icon: <IoDocuments />,
          cName: "sub-nav-text",
        },
        {
          title: "Term",
          path: "/data-source/term",
          icon: <TiDocumentText />,
          cName: "sub-nav-text",
        },
        {
          title: "Data Record",
          path: "/data-source/data-record",
          icon: <HiDocumentDuplicate />,
          cName: "sub-nav-text",
        },
        {
          title: "Value Chain Paragraph Extract",
          path: "/data-source/pragraph-extract",
          icon: <CgPlayListSearch />,
          cName: "sub-nav-text",
        },
      ],
    },
    {
      title: "User Masters",
      path: "#",
      icon: <BsList />,
      cName: "sub-nav-text",
      roles: ["Admin"],
      subNav: [
        {
          title: "User",
          path: "/usersmaster/userMaster",
          icon: <BsPeople />,
          cName: "sub-nav-text",
        },
        {
          title: "Subscriber",
          path: "/usersmaster/userRole",
          icon: <BsBuildings />,
          cName: "sub-nav-text",
        },
        {
          title: "User Group",
          path: "/usersmaster/userGroup",
          icon: <BsCollection />,
          cName: "sub-nav-text",
        },
      ],
    },
  ];
};

export const SidebarData: SidebarGroup[] = [
  {
    title: "Home",
    path: "/home",
    icon: <AiOutlineHome />,
    cName: "nav-text text-left",
    roles: ["Admin", "user"],
  },
  {
    title: "Library Category",
    path: "/library/library-category",
    icon: <GiBookshelf />,
    cName: "nav-text text-left",
    roles: ["Admin"],
  },
  {
    title: "Private Library",
    path: "#",
    icon: <BsBook />,
    cName: "sub-nav-text",
    roles: ["Admin"],
  },
  {
    title: "AI Dharma Library",
    path: "/pdf-library",
    icon: <IoLibraryOutline />,
    cName: "nav-text text-left",
    roles: ["Admin", "user"],
  },
  {
    title: "DataSource Mangement",
    path: "#",
    icon: <BsList />,
    cName: "sub-nav-text",
    roles: ["Admin"],
    subNav: [
      {
        title: "Agent Master",
        path: "/data-source/agent-master",
        icon: <MdManageAccounts />,
        cName: "sub-nav-text",
      },
      {
        title: "Value Chain Category",
        path: "/data-source/value-chain-category",
        icon: <GiGears />,
        cName: "sub-nav-text",
      },
      {
        title: "Value Chain",
        path: "/data-source/value-chain",
        icon: <PiGearBold />,
        cName: "sub-nav-text",
      },
      {
        title: "Data Pipeline Category",
        path: "/data-source/data-pipeline-category",
        icon: <GiPipes />,
        cName: "sub-nav-text",
      },
      {
        title: "Data Pipeline",
        path: "/data-source/data-pipeline",
        icon: <SiMediafire />,
        cName: "sub-nav-text",
      },
      {
        title: "Term Set",
        path: "/data-source/term-set",
        icon: <IoDocuments />,
        cName: "sub-nav-text",
      },
      {
        title: "Term",
        path: "/data-source/term",
        icon: <TiDocumentText />,
        cName: "sub-nav-text",
      },
      {
        title: "Data Record",
        path: "/data-source/data-record",
        icon: <HiDocumentDuplicate />,
        cName: "sub-nav-text",
      },
      {
        title: "Value Chain Paragraph Extract",
        path: "/data-source/pragraph-extract",
        icon: <CgPlayListSearch />,
        cName: "sub-nav-text",
      },
    ],
  },
  {
    title: "User Masters",
    path: "#",
    icon: <BsList />,
    cName: "sub-nav-text",
    roles: ["Admin"],
    subNav: [
      {
        title: "User",
        path: "/usersmaster/userMaster",
        icon: <BsPeople />,
        cName: "sub-nav-text",
      },
      {
        title: "Subscriber",
        path: "/usersmaster/userRole",
        icon: <BsBuildings />,
        cName: "sub-nav-text",
      },
      {
        title: "User Group",
        path: "/usersmaster/userGroup",
        icon: <BsCollection />,
        cName: "sub-nav-text",
      },
    ],
  },
];